import React from 'react'

import i18n from 'i18n-literally'
import PropTypes from 'prop-types'

import { Typography } from '@mui/material'

import { annotationLabels } from '~/src/Annotations/constants'
import { useAllowedAnnotationTypes } from '~/src/Annotations/utils'
import { idAndNameShape, idPropType } from '~/src/Lib/PropTypes'
import { formatList } from '~/src/Lib/Utils'

const displayName = 'EmptyJournal'

const EmptyJournal = ({
  classes,
  annotationTypes,
  rooms,
  checkedRooms: checkedRoomIds,
  searchTerms,
  relatedUser = null,
  relatedUsers,
  facilityLocationsTerm,
}) => {
  const user = relatedUsers.filter(ru => ru.id === relatedUser)
  const allowedAnnotationTypes = useAllowedAnnotationTypes()

  const checkedRooms = checkedRoomIds.map(roomId => rooms[roomId])

  const locationsTerm = facilityLocationsTerm(checkedRooms.length ? checkedRooms : rooms)

  const selectedTypes = annotationTypes
    .filter(t => t in annotationLabels && allowedAnnotationTypes.has(t))
    .map(t => (annotationLabels[t] ? ` ${annotationLabels[t]}` : ''))

  return (
    <Typography
      className={classes.emptyJournalState}
      variant="subtitle1"
      color="textPrimary"
      gutterBottom
    >
      {i18n`There are no`}
      {` ${formatList(selectedTypes, i18n`or`)} `}
      {annotationTypes.filter(t => t !== 'harvest').length !== 1 ? i18n`entries ` : ''}
      in
      {!checkedRooms.length ? i18n` all ` : ` ${checkedRooms.map(room => ` ${room.name}`)} `} {checkedRooms.length !== 1 ? locationsTerm : ''}
      {searchTerms ? i18n` matching '${searchTerms}' ` : ' '}
      {relatedUser ? i18n` for ` : ' '}
      {relatedUser ? <span className={classes.userName}>{user[0].fullName}</span> : ' '}
      {i18n` in the journal.`}
    </Typography>
  )
}

EmptyJournal.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  rooms: PropTypes.objectOf(idAndNameShape).isRequired,
  annotationTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  checkedRooms: PropTypes.arrayOf(PropTypes.number).isRequired,
  searchTerms: PropTypes.string.isRequired,
  relatedUser: idPropType.nullable,
  relatedUsers: PropTypes.arrayOf(idAndNameShape).isRequired,
  facilityLocationsTerm: PropTypes.func.isRequired,
}
EmptyJournal.displayName = displayName

export default React.memo(EmptyJournal)
